import Filter from '@/library/filter/filter.interface';
import FiltersObject from '@/library/filter/filters-object.interface';

export default class Filters {
    public searchFilter: Filter | null = null;
    private filters: Filter[][] = [];

    /**
     * SearchQuery()
     * Filter[]
     * and
     * Filter[] (OR)
     * and
     * Filter[] (OR)
     */

    public applyFilters(filters: Filter[][]): void {
        this.filters = filters;
    }

    public applySearch(filter: Filter): void {
        this.searchFilter = filter.value === '' ? null : filter;
    }

    public filtersObject(): FiltersObject {
        const filters: FiltersObject = {};
        this.filters.forEach((filtersGroup: Filter[]) => {
            return filtersGroup.forEach((filter: Filter) => {
                if (!filters[filter.name]) {
                    filters[filter.name] = [];
                }
                filters[filter.name].push(filter.object());
            });
        });
        return filters;
    }

    public query(): string {
        return this.filters
            .map((filtersGroup: Filter[]) => {
                const groupQuery = filtersGroup
                    .map((filter: Filter) => filter.query())
                    .join(' || ');
                return '(' + groupQuery + ')';
            })
            .join(' && ');
    }

    public exists(name: string): boolean {
        return this.filters.some((subFilters: Filter[]) => {
            return subFilters.some(filter => filter.name === name);
        });
    }

    public find(name: string): Filter | null {
        const foundFilter = this.filters
            .map((subFilters: Filter[]) => subFilters.find((filter: Filter) => filter.name === name) || null)
            .filter((filter: Filter | null) => !!filter)
        return foundFilter.length > 0 ? foundFilter[0] : null;
    }

    public hasFilters(): boolean {
        return this.count() > 0;
    }

    public count(): number {
        const filtersCount = this.filters.reduce((currentCount, row) => currentCount + row.length, 0);
        const searchCount = !this.searchFilter ? 0 : 1;
        return filtersCount + searchCount;
    }
}
